export function safelyParseJSON(json) {
  let parsed
  try {
    parsed = JSON.parse(json)
  } catch (e) {
    /* do nothing */
  }
  return parsed // Could be undefined
}
